import { useTheme } from "styled-components";

import { Theme } from "../designTokens";

export type Scale = "tiny" | "small" | "medium" | "big" | "huge" | "gigantic";

export type IconPrority = "primary" | "secondary";
export type IconColor =
  | "gray"
  | "brand"
  | "auxiliary"
  | "accent"
  | "error"
  | "currentColor";

export type PassedProps = {
  priority?: IconPrority;
  color?: IconColor;
  isOnDarkBackground?: boolean;
  scale?: Scale;
};

export type MappedProps = {
  color: string;
  height?: number;
  width?: number;
};

export const colorByPriority = {
  primary: (theme: Theme, baseColor: IconColor = "gray") => {
    switch (baseColor) {
      case "accent":
        return theme.palette[baseColor].dark;
      case "brand":
        return theme.palette[baseColor].dark;
      case "currentColor":
        return "currentColor";
      default:
        return theme.palette[baseColor].main;
    }
  },
  secondary: (theme: Theme, baseColor: IconColor = "gray") => {
    switch (baseColor) {
      case "error":
        return theme.palette.error.main;
      case "brand":
        return theme.palette.brand.main;
      case "currentColor":
        return "currentColor";
      case "gray":
      case "accent":
      default:
        return theme.palette[baseColor].light;
    }
  },
};

const getSize = (scale?: Scale) => {
  switch (scale) {
    case "small":
      return 32;
    case "medium":
      return 64;
    case "huge":
      return 128;
    case "gigantic":
      return 180;
    case "big":
    default:
      return 96;
  }
};

export const useMappedProps = ({
  scale,
  priority = "primary",
  isOnDarkBackground,
  color,
  ...rest
}: PassedProps): MappedProps => {
  const theme = useTheme();
  return {
    ...rest,
    color: isOnDarkBackground
      ? theme.palette.white
      : colorByPriority[priority](theme, color),
    height: getSize(scale),
    width: getSize(scale),
  };
};
